"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Lock;
    }
});
var _react = /*#__PURE__*/ _interopRequireDefault(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function Lock(props) {
    var svgProps = Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 26 32",
        width: "26",
        height: "32",
        fill: "currentColor"
    }, props);
    return /*#__PURE__*/ _react.default.createElement("svg", _extends({}, svgProps), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M20 11H18V7C18 5.67392 17.4732 4.40215 16.5355 3.46447C15.5979 2.52678 14.3261 2 13 2C11.6739 2 10.4021 2.52678 9.46447 3.46447C8.52678 4.40215 8 5.67392 8 7V11H6V7C6 5.14348 6.7375 3.36301 8.05025 2.05025C9.36301 0.737498 11.1435 0 13 0C14.8565 0 16.637 0.737498 17.9497 2.05025C19.2625 3.36301 20 5.14348 20 7V11Z",
        fill: props.fill || "white"
    }), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M24 13H2C1.46957 13 0.960859 13.2107 0.585786 13.5858C0.210714 13.9609 0 14.4696 0 15V30C0 30.5304 0.210714 31.0391 0.585786 31.4142C0.960859 31.7893 1.46957 32 2 32H24C24.5304 32 25.0391 31.7893 25.4142 31.4142C25.7893 31.0391 26 30.5304 26 30V15C26 14.4696 25.7893 13.9609 25.4142 13.5858C25.0391 13.2107 24.5304 13 24 13ZM14 24.858V27C14 27.2652 13.8946 27.5196 13.7071 27.7071C13.5196 27.8946 13.2652 28 13 28C12.7348 28 12.4804 27.8946 12.2929 27.7071C12.1054 27.5196 12 27.2652 12 27V24.858C11.0573 24.6146 10.2358 24.0358 9.6894 23.23C9.14299 22.4242 8.90921 21.4468 9.03188 20.481C9.15456 19.5152 9.62526 18.6273 10.3558 17.9837C11.0863 17.3401 12.0264 16.985 13 16.985C13.9736 16.985 14.9137 17.3401 15.6442 17.9837C16.3747 18.6273 16.8454 19.5152 16.9681 20.481C17.0908 21.4468 16.857 22.4242 16.3106 23.23C15.7642 24.0358 14.9427 24.6146 14 24.858V24.858Z",
        fill: props.fill || "white"
    }));
}

//# sourceMappingURL=Lock.js.map